module.exports = __webpack_public_path__ + "img/button-shop.58a83519.png";